import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ABExperimentService } from "@obg/core.experiment";
import { AuthSelector } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { ConfigService } from "@obg/ngx.global";
import { ignoreNil } from "@obg/rxjs";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Injectable()
export class PropMessageService {
	isEnabled$: Observable<boolean> = this.store.select(AuthSelector.isAuthenticated).pipe(
		ignoreNil(),
		map((isAuthenticated) => {
			if (isAuthenticated) {
				return false;
			}
			const configEnabled = this.configService.get((x) => x.common.propMessage?.isEnabled, false);
			return configEnabled || this.abExperimentService.getExperimentVariant("pm") === "1";
		}),
		startWith(false)
	);

	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>,
		private abExperimentService: ABExperimentService,
		private store: Store<CoreContentState>
	) {}
}
